<!--
  Program: MultiSelectCheckbox
  Author: SDL
  Brief: Input using regex @focusout="hanldeClickFocusOut"
-->
<template>
    <div class="select-dropdown form-control" tabindex="0">
      <div class="selected-option" @click.stop="hanldeClick">
         {{ selectedLabels.length ? selectedLabels.toString() : 'Select' }}
        <i class="material-icons arrow-bottom">keyboard_arrow_down</i>
      </div>
      <ul class="options-ul" id="options-ul-cstm">
        <li class="sub-item"  @click.stop="handleSelectAll">
          <input type="checkbox"  v-model="selectAll" />
          All
        </li>
        <li class="sub-item" v-for="(item, index) in optionList" :key="item.code" @click.stop="toggleoption(item.code)">
          <input type="checkbox" :value="item.code" v-model="selectedOptions"/>
          {{ getLabel(item) }}
        </li>         
      </ul>
    </div>
  </template>
   
  <script>
  import SDLLocale from '@/mixin/SDLLocale';

  export default {
    name: 'sdl-multiselect-checkbox',
    mixins: [SDLLocale],
    props: {
      optionList:{
        required:true,
        type: [Array]
      },
      regionSelected : {
        type: [Array]
      }
    },
    data() {
      return {
        selectAll: false,
        selectedOptions:[],
        selectedLabels: []
      };
    },
    methods: {
      hanldeClick(){
        let a = document.getElementById('options-ul-cstm')
        a.style.display = 'block';
      },  
      handleSelectAll(){
        this.selectedOptions = []
        this.selectAll = !this.selectAll
        if(!this.selectAll){
          this.selectedOptions = [];
          return;
        }
        this.optionList.forEach(element => {
          this.selectedOptions.push(element.code)
        });
        this.$emit('change',  this.selectedOptions);
      },
      toggleoption(value){
        if(this.selectedOptions.includes(value)){
          this.selectedOptions = this.selectedOptions.filter((opt)=>opt !== value);
          this.$emit('change',  this.selectedOptions);
        }else{
          this.selectedOptions.push(value);
          this.$emit('change',  this.selectedOptions);
        }
    },
    },
    watch: {
      'regionSelected': function(newVal, oldVal){
        this.selectedOptions = newVal
      },
      selectedOptions: function(newVal){
        if(!newVal.length) return this.selectedLabels = []
        let arr = []
        newVal.forEach(val => {
          this.optionList.map((item)=>{
            if(item.code == val){
              let label = this.getLabel(item)
              arr.push(label)
            }
          })
          this.selectedLabels = arr
        });
      }
    },
    mounted() {
    },
  };
  </script>

<style scoped>

  .select-dropdown{
    position: relative;
    width: 200px !important;
  }
  .selected-option {
    padding: 5px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .options-ul {
    display: none;
    position: absolute;
    left:0;
    border: 1px solid #ccc;
    list-style: none;
    width: inherit;
    z-index: 1;
    background-color: #fff;

  }
  .options-ul li {
    padding: 5px;
    cursor: pointer;
  }
  .options-ul li:hover {
    background-color: #007aff;
    color: #fff
  }
  .select-dropdown:hover .options-ul{
    /* display: block; */
  }
  .arrow-bottom {
    position: absolute;
    right: 0;
    color: #ccc;
    font-size: 20px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/common/control/multiSelectCheckbox/MultiSelectCheckbox.vue